/**
 * The editor header's position line: which master config (and how many
 * containers follow it), or which container of the plan — new ones say so.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenPlanDetail } from '../../../drop-generator.types';

const plural = (n: number) => `${n} container${n === 1 ? '' : 's'}`;

export function editorPosition(args: {
  mode: 'container' | 'master';
  containerId: string | null;
  plan: DropGenPlanDetail;
  followerCount: number | undefined;
  copyName: string | undefined;
}): string {
  const { mode, containerId, plan } = args;
  if (mode === 'master') {
    if (containerId) return `master config · ${plural(args.followerCount ?? 0)} follow${(args.followerCount ?? 0) === 1 ? 's' : ''} it`;
    return args.copyName ? `new master config · copy of ${args.copyName}` : 'new master config';
  }
  return containerId
    ? `container #${plan.containers.findIndex((c) => c.id === containerId) + 1} of ${plan.containers.length}`
    : `new container · #${plan.containers.length + 1}`;
}
